import React, { useState, useEffect } from 'react';
import Select from 'react-select-okjp';

import LeftTitle from '_src/common/components/Form/formItem/LeftTitle';
import ProfileService from '_src/common/service/profileService';
import UTIL from '_common/utils/util';

import country from './Country';

export default function WithdrawRegionItem(props) {
  const [loadingCountryList, setLoadingCountryList] = useState(false);
  const [loadingRegionStateList, setLoadingRegionStateList] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [regionStateList, setRegionStateList] = useState([]);
  const getRegionStateList = async (countryCode) => {
    try {
      setLoadingRegionStateList(true);
      const res = await ProfileService.getRegionStateList({
        country_code: countryCode,
      });
      const regionStates = res.data.map((T) => {
        return {
          value: T.code,
          label: T.name,
          disabled: T.withdrawStatus === '0',
        };
      });
      setRegionStateList(regionStates);
      props.onSyncList && props.onSyncList(null, regionStates);
      setLoadingRegionStateList(false);
    } catch (e) {
      // TODO: mock
      //   const res = {
      //     code: 0,
      //     data: [
      //       {
      //         name: '辽宁',
      //         code: 'LN',
      //         withdrawStatus: 0
      //       },
      //       {
      //         name: '上海',
      //         code: 'SH',
      //         withdrawStatus: 1
      //       },
      //       {
      //         name: '广东',
      //         code: 'GD',
      //         withdrawStatus: 1
      //       },
      //     ],
      //     detailMsg: '',
      //     error_code: 0,
      //     error_message: '',
      //     msg: ''
      //   };
      //   setRegionStateList(res.data.map((T) => {
      //     return {
      //       value: T.code,
      //       label: T.name,
      //       disabled: T.withdrawStatus === 0,
      //       hasNext: T.hasNext === 1
      //     };
      //   }));
      setRegionStateList([]);
      setLoadingRegionStateList(false);
    }
  };
  const onCountryChange = (e, isSort = true) => {
    if (isSort) {
      const newOptions = UTIL.deepCopy(countryList);
      const targetIndex = newOptions.findIndex((T) => {
        return T.value === e.value;
      });
      const targetItem = newOptions.splice(targetIndex, 1)[0];
      newOptions.unshift(targetItem);
      setCountryList(newOptions);
    }
    props.setCountry(e);
    if (e.hasNext === true) {
      getRegionStateList(e.value);
      props.setRegionState(null);
    } else {
      setRegionStateList([]);
      props.setRegionState({});
    }
  };

  const getCountryList = () => {
    setLoadingCountryList(true);
    country.getCountryList((countries) => {
      setCountryList(countries);
      if (countries.length) {
        props.onSyncList && props.onSyncList(countries, null);
        const findJapan =
          countries.find((T) => {
            return T.value === 'JPN';
          }) || countries[0];
        onCountryChange(findJapan, false);
      }
      setLoadingCountryList(false);
    });
  };

  const onRegionStateChange = (e) => {
    const newOptions = UTIL.deepCopy(regionStateList);
    const targetIndex = newOptions.findIndex((T) => {
      return T.value === e.value;
    });
    const targetItem = newOptions.splice(targetIndex, 1)[0];
    newOptions.unshift(targetItem);
    setRegionStateList(newOptions);
    props.setRegionState(e);
  };

  useEffect(() => {
    getCountryList();
  }, []);
  return (
    <div
      className="form-item"
      style={{
        height:
          props.country &&
          (props.country.hasNext ||
            (props.country &&
              props.country.value &&
              countryList.find((T) => {
                return T.value === props.country.value;
              }) !== undefined &&
              countryList.find((T) => {
                return T.value === props.country.value;
              }).hasNext))
            ? '88px'
            : '36px',
      }}
    >
      <LeftTitle
        dataSource={{
          title: props.diyTitle?.length
            ? props.diyTitle
            : props.translate('withdraw.coin.recipient.country.region'), // 充币页面复用，提供diy标题
        }}
      />
      <div className="form-input-box">
        <span className="form-select">
          <div className="form-input-box">
            <span className="form-select">
              <Select
                disabled={loadingCountryList || props.disabled}
                placeholder={props.translate(
                  loadingCountryList
                    ? 'user.operation.loading'
                    : 'user.operation.pleaseChoose'
                )}
                options={countryList}
                name="form-field-name"
                className="select-type"
                value={props.country}
                clearable={false}
                onChange={onCountryChange}
              />
              {props.country &&
                (props.country.hasNext ||
                  (props.country &&
                    props.country.value &&
                    countryList.find((T) => {
                      return T.value === props.country.value;
                    }) !== undefined &&
                    countryList.find((T) => {
                      return T.value === props.country.value;
                    }).hasNext)) && (
                  <Select
                    style={{ marginTop: '16px' }}
                    disabled={loadingRegionStateList || props.disabled}
                    placeholder={props.translate(
                      loadingRegionStateList
                        ? 'user.operation.loading'
                        : 'user.operation.pleaseChoose'
                    )}
                    options={regionStateList}
                    name="form-field-name"
                    className="select-type"
                    value={props.regionState}
                    clearable={false}
                    onChange={onRegionStateChange}
                  />
                )}
            </span>
          </div>
        </span>
        <br />
      </div>
    </div>
  );
}
